import { render, staticRenderFns } from "./addenterprise.vue?vue&type=template&id=670c7214&scoped=true&"
import script from "./addenterprise.vue?vue&type=script&lang=js&"
export * from "./addenterprise.vue?vue&type=script&lang=js&"
import style0 from "./addenterprise.vue?vue&type=style&index=0&id=670c7214&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670c7214",
  null
  
)

export default component.exports